import { render } from "./Error403.vue?vue&type=template&id=454958f5&ts=true"
import script from "./Error403.vue?vue&type=script&lang=ts"
export * from "./Error403.vue?vue&type=script&lang=ts"

import exportComponent from "/home/quangphuc/s-tech/admin-nhaongay/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__